import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import Home from './pages/Home';
import Receitas from './pages/Receitas';
import Progresso from './pages/Progresso';
import PlanoAlimentar from './pages/PlanoAlimentar';
import Perfil from './pages/Perfil';
import MedicoDashboard from './pages/MedicoDashboard';
import PacienteDetalhes from './pages/PacienteDetalhes';
import AdminDashboard from './pages/AdminDashboard';
import AdminPacienteDetalhes from './pages/AdminPacienteDetalhes';
import AdminPerfilPaciente from './pages/AdminPerfilPaciente';
import AdminPacienteDashboard from './pages/AdminPacienteDashboard';
import Chat from './pages/Chat';
import { SplashScreen } from './components/SplashScreen';
import '@/App.css';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground">Carregando...</div>
      </div>
    );
  }

  return user ? children : <Navigate to="/login" />;
};

const AppRoutes = () => {
  const { user } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            {user?.role === 'admin' ? <Navigate to="/admin/dashboard" /> : 
             user?.role === 'doctor' ? <Navigate to="/medico/dashboard" /> : <Home />}
          </PrivateRoute>
        }
      />
      <Route
        path="/receitas"
        element={
          <PrivateRoute>
            <Receitas />
          </PrivateRoute>
        }
      />
      <Route
        path="/progresso"
        element={
          <PrivateRoute>
            <Progresso />
          </PrivateRoute>
        }
      />
      <Route
        path="/plano-alimentar"
        element={
          <PrivateRoute>
            <PlanoAlimentar />
          </PrivateRoute>
        }
      />
      <Route
        path="/perfil"
        element={
          <PrivateRoute>
            <Perfil />
          </PrivateRoute>
        }
      />
      <Route
        path="/medico/dashboard"
        element={
          <PrivateRoute>
            <MedicoDashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/medico/paciente/:patientId"
        element={
          <PrivateRoute>
            <PacienteDetalhes />
          </PrivateRoute>
        }
      />
      <Route
        path="/chat/:userId"
        element={
          <PrivateRoute>
            <Chat />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/dashboard"
        element={
          <PrivateRoute>
            <AdminDashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/paciente/:patientId"
        element={
          <PrivateRoute>
            <AdminPacienteDashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/paciente/:patientId/receitas"
        element={
          <PrivateRoute>
            <AdminPacienteDetalhes />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/paciente/:patientId/plano"
        element={
          <PrivateRoute>
            <AdminPacienteDetalhes />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/paciente/:patientId/perfil"
        element={
          <PrivateRoute>
            <AdminPerfilPaciente />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <SplashScreen />
          <AppRoutes />
          <Toaster position="top-right" />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;